<template>
  <div>
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="box-header">
        <span class="box-header__title">Список работников</span>
        <el-button class="box-header__button" size="mini" @click="addWorker" type="primary">Добавить</el-button>
      </div>
      <template>
        <el-table :data="tableData" class="table">
          <el-table-column prop="id" label="id"></el-table-column>
          <el-table-column label="Имя">
            <template slot-scope="scope">
              <el-link type="primary" @click="editWorker(scope.row.id)">
                {{
                  [scope.row.surname, scope.row.name, scope.row.patronymic].join(' ')
                }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column label="Пол">
          <template slot-scope="scope" v-if="scope.row.gender">
              {{ scope.row.gender.title[0] }}
          </template>
        </el-table-column>
          <el-table-column label="Телефон" prop="phone"></el-table-column>
          <el-table-column label="E-mail" prop="email"></el-table-column>
          <el-table-column fixed="right" align="center" width="140" label="Действия">
            <template slot-scope="scope">
              <el-tooltip content="Редактировать" placement="top">
                <el-button
                  class="table__btn"
                  size="mini"
                  type="primary"
                  icon="el-icon-edit"
                  circle
                  @click="editWorker(scope.row.id)"
                />
              </el-tooltip>
              <el-tooltip content="Удалить работника" placement="top">
                <el-popconfirm
                  class="confirmBtn"
                  @onConfirm="deleteWorker(scope.row.id, scope.$index)"
                  title="Вы уверены?"
                  confirmButtonText="Да"
                  confirmButtonType="danger"
                  cancelButtonType="default"
                  cancelButtonText="Нет"
                >
                  <el-button
                    size="mini"
                    icon="el-icon-delete"
                    circle
                    class="table__btn"
                    slot="reference"
                    type="danger"
                  />
                </el-popconfirm>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          v-if="showPagination"
          class="pagination"
          background
          layout="prev, pager, next"
          :page-size="pagination.per_page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          @current-change="loadLogic"
        ></el-pagination>

      </template>
      <div class="error-load" v-if="errorLoadCard">
        <p>Ошибка загрузки</p>
        <el-button type="danger" @click="loadLogic">Загрузить еще раз</el-button>
      </div>
    </el-card>

    <worker-add
      :visible="workerAddModal"
      @close="workerAddModal = false"
      @update="loadLogic"
    />

    <worker-edit
      :visible="workerEditModal"
      @close="workerEditModal = false"
      @update="loadLogic"
      :worker="selectWorker"
    />

  </div>
</template>

<script>
import WorkerAdd from '@/components/dialog/worker/Add'
import WorkerEdit from '@/components/dialog/worker/Edit'

export default {
  name: 'Worker.list',
  data () {
    return {
      tableData: null,
      loading: false,
      errorLoadCard: false,
      // Worker: {
      //   title: null,
      //   description: null
      // },
      editFormRules: {
        surname: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        birthday: [
          { required: true, message: 'Заполните поле', trigger: 'blur' }
        ],
        password: [
          { required: false, message: 'Заполните поле', trigger: 'blur' }
        ],
        phone: [
          { required: false, message: 'Заполните поле', trigger: 'blur' }
        ],
        email: [
          { validator: this.checkEmail, required: true, trigger: 'blur' },
          { type: 'email', message: 'Укажите валидный e-mail', trigger: ['blur', 'change'] }
        ],
        gender_id: [
          { required: true, message: 'Укажите пол', trigger: 'blur' }
        ],
        type: [{ required: true, message: 'Выберите роль', trigger: 'blur' }]
      },
      error: null,
      cardId: null,
      selectWorker: false,
      workerAddModal: false,
      workerEditModal: false,
      pagination: null
    }
  },
  created () {
    this.loading = !!1
    this.loadLogic()
  },
  computed: {
    showPagination () {
      if (this.pagination) {
        return this.pagination.total > this.pagination.per_page
      } else return false
    }
  },
  components: { WorkerAdd, WorkerEdit },
  methods: {
    loadLogic (page = 1) {
      this.loading = !!1

      const params = {
        params: {
          page
        }
      }

      this.$api.doctor
        .getList(params)
        .then((response) => {
          this.tableData = response.data.data
          if (response.data.meta) this.pagination = response.data.meta.pagination
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка загрузки списка',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    },
    editWorker (id) {
      this.$router.push({
        name: 'cpanel.worker.item',
        params: {
          id
        }
      })

      // this.selectWorker = id
      //
      // this.workerEditModal = !!1
    },
    addWorker () {
      this.workerAddModal = !!1
    },
    deleteWorker (id, idIndex) {
      this.loading = !!1
      this.$api.doctor
        .delete(id)
        .then((response) => {
          this.loadData = response.data
          this.$notify.success({
            title: 'Успешно',
            message: 'Сотрудник удален!'
          })
          this.tableData.splice(idIndex, 1)
        })
        .catch((response) => {
          this.$notify.error({
            title: 'Ошибка авторизации',
            message: response.response.data.message
          })
        })
        .finally(() => {
          this.loading = !!0
        })
    }
  }
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 1960px;
  margin: 0 auto;

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #aaaeba;
    margin: 5px 0 40px 0;
  }

  &__btns {
    text-align: center;
    margin: 50px 0 0 0;
  }
}

.table {
  width: 100%;

  &__btn {
    margin: 5px;
  }
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.box-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.pagination {
  margin-top: 10px;
  padding: 0;
}
</style>
